import React, { useState } from 'react';

import './Index.css';
import { LabeledInput, SelectInput } from '../../../Components';

import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { AccessManagementpopup, AccessManagemnetTable, ConfirmPassword } from '../..';
const Index = () => {
    const [userName, setUserName] = useState('');
    const [email, setEmail] = useState('');
    const [name, setName] = useState('');
    const [id, setId] = useState('');
    const [password, setPassword] = useState('');
    const [phone, setPhoen] = useState('');
    const [rowPerPage, setRowPerPage] = useState(10);
    const [confirmPassword, setConfirmPassword] = useState(false);
    const [showdetails, setShowdetails] = useState(false);
    return (
        <>
            <AccessManagementpopup
                state={showdetails}
                setStateFalse={() => {
                    setShowdetails((prev) => !prev);
                }}
                name={name}
                id={id}
            />
            <ConfirmPassword
                state={confirmPassword}
                setStateFalse={() => {
                    setConfirmPassword((prev) => !prev);
                }}
                onConfirmHandler={() => {
                    setId('ID1');
                    setShowdetails((prev) => !prev);
                    setConfirmPassword((prev) => !prev);
                }}
            />
            <div className="accessManagement">
                <div className="accessManagement_head">
                    <h2>Accesss Management</h2>
                </div>
                <div className="accessManagement_mid">
                    <div style={{ display: 'flex' }}>
                        <LabeledInput
                            name="product name"
                            value={userName}
                            changeHandler={(e) => {
                                setUserName(e.target.value);
                            }}
                            label={'Name'}
                        />
                    </div>

                    <div style={{ marginTop: '1rem', display: 'flex' }} className="accessManagement_mid_right">
                        <button style={{ marginRight: '2rem' }} className="btn-gray">
                            Reset
                        </button>
                        <button className="btn-orange">
                            <p>Search</p>
                        </button>
                    </div>
                </div>
                <div className="accessManagement_head">
                    <p>Create A new user</p>
                </div>
                <div className="accessManagement_mid">
                    <div style={{ display: 'flex', flex: '1', justifyContent: 'space-between', flexWrap: 'wrap' }}>
                        <LabeledInput
                            name="product name"
                            value={name}
                            changeHandler={(e) => {
                                setName(e.target.value);
                            }}
                            label={'Name'}
                        />
                        <LabeledInput
                            style={{ marginRight: '1rem' }}
                            name="product name"
                            value={password}
                            changeHandler={(e) => {
                                setPassword(e.target.value);
                            }}
                            label={'Password'}
                            type="password"
                        />
                        <LabeledInput
                            name="phone"
                            value={phone}
                            changeHandler={(e) => {
                                setPhoen(e.target.value);
                            }}
                            label={'Phone'}
                            type="tel"
                        />
                        <LabeledInput
                            name="product name"
                            value={email}
                            changeHandler={(e) => {
                                setEmail(e.target.value);
                            }}
                            label={'Email'}
                            type="email"
                        />
                    </div>
                    <div style={{ marginLeft: '2rem', display: 'flex' }} className="accessManagement_mid_right">
                        <button
                            onClick={() => {
                                setConfirmPassword((prev) => !prev);
                            }}
                            className="btn-orange"
                        >
                            <p>Create</p>
                        </button>
                    </div>
                </div>
                <AccessManagemnetTable />
                <div className="pagination_footer">
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <SelectInput
                            marginZero
                            style={{ minWidth: '30px' }}
                            label="Rows per page:"
                            value={rowPerPage}
                            changeHandler={(e) => {
                                setRowPerPage(e.target.value);
                            }}
                            options={[
                                { name: '10', value: 10 },
                                { name: '25', value: 25 },
                                { name: '50', value: 50 },
                            ]}
                        />
                    </div>
                    <div className="pagination_footer_pageinfo">
                        <p className="page_details">1-2 of 2</p>
                        <div>
                            <ChevronLeftIcon className={`footer_pagination_icon disabled`} />
                            <ChevronRightIcon className={`footer_pagination_icon`} />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Index;
